// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"1e39fcf7","609":"b0b6ee60"}[chunkId] + ".js";
};